import i18n from "./i18n";
import API from "../Network/API";

// Set once the visitor picks a language themselves; location is never used after that.
const CHOSEN_KEY = "xller_lang_chosen";
// Set once the location lookup has run, so it only happens on the first visit.
const GEO_KEY = "xller_geo_locale";

function storageGet(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

function storageSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {}
}

// The language API requests should be answered in (sent as the X-Locale header).
export function currentLanguage() {
  return (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);
}

// On the first visit, pick the site language from the visitor's country (e.g. UAE -> Arabic).
export async function applyGeoLocale() {
  if (storageGet(CHOSEN_KEY) || storageGet(GEO_KEY)) return;
  try {
    const response = await API.get("/v1/oauth/geo-locale", { timeout: 2000 });
    const locale = response.data?.data?.locale;
    storageSet(GEO_KEY, locale || "none");
    if (locale && locale !== currentLanguage() && i18n.options.supportedLngs.includes(locale)) {
      await i18n.changeLanguage(locale);
    }
  } catch (e) {
    // Location lookup is best effort; keep the detected browser language and don't
    // retry (and delay first render) on every page load.
    storageSet(GEO_KEY, "none");
  }
}

// Manual switch from the language menu. Reloads so content already fetched from the API
// (courses, categories) is fetched again in the new language.
export function switchLanguage(lng) {
  storageSet(CHOSEN_KEY, lng);
  if (lng === currentLanguage()) return;
  i18n.changeLanguage(lng).then(() => window.location.reload());
}
